module.exports = __webpack_public_path__ + "static/media/bg_invite_screen.9c231e0e.png";